import { useCallback, useEffect } from 'react';

import { useAuthentication } from '@givebacks/api';
import { User, useUserData } from '@givebacks/api/core';
import { usePlatformService } from 'core/Hooks';
import { Navigate, Route, Routes, useLocation, useSearchParams } from 'react-router-dom';
import { LoadingOverlay } from 'ui';

import { useNativeAddCard } from '../../hooks/mobile/useNativeApp';
import { AddCard } from '../../pages/Account/AddCard/AddCard';
import { ShortSessionAddCard } from '../../pages/ShortSessions/AddCard';
import { InAppShortSessionsLayout } from '../Layouts/InAppShortSessionsLayout';

// Define components that are booth short session routes and also desktop routes.
// If needed we can also perform native specific action here.
// This allows us to have one route do specific functions depending on the needed context
// We can further wrap these components in the shortSession controller to
export const WalletAddCard = () => {
  const { isAuthenticated } = useAuthentication();

  const {
    isLoading: isQueryLoading,
    data: session,
    isEnabled,
  } = useUserData(useCallback((data: User) => data.session, []));
  const Platform = usePlatformService();
  const { openNativeAddCard } = useNativeAddCard({});

  // Open the add card screen on native
  useEffect(() => {
    if (Platform.isNative) void openNativeAddCard();
  }, [Platform.isNative, openNativeAddCard]);

  if (isQueryLoading && isEnabled) {
    return <LoadingOverlay visible />;
  }
  // Handle the background route change to the wallet page
  if (Platform.isNative) return <Navigate to="/wallet" />;

  // All session that were short end up here. This "Should" mean that the native pages get caught here by default.
  if (session?.short_session) {
    return (
      <Routes>
        <Route element={<InAppShortSessionsLayout />}>
          <Route index element={<ShortSessionAddCard />} />
        </Route>
      </Routes>
    );
  }
  // If we made it here we're not authenticated and we are not on a native device, we should at this time, redirect
  if (!isAuthenticated && !Platform.isNative) {
    return <Navigate to="/sign-in?redirect=/account/card" replace />;
  }

  if (isAuthenticated && !Platform.isNative) {
    return <AddCard />;
  }

  return <Navigate to="/account/card" replace />;
};

// Used to redirect to the correct page after a short session is created
const AuthShortSessionRoute = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('redirect');
  return <Navigate to={`${redirect}${location.search}` || '/offers'} replace />;
};

export { AuthShortSessionRoute };
